export * from './AwardCupIcon';
export * from './AwardCupIcon16Light';
export * from './AwardCupIcon16Regular';
export * from './AwardCupIcon16Solid';
export * from './AwardCupIcon20Light';
export * from './AwardCupIcon20Regular';
export * from './AwardCupIcon20Solid';
export * from './AwardCupIcon24Regular';
export * from './AwardCupIcon24Solid';
export * from './AwardCupIcon32Regular';
export * from './AwardCupIcon64Regular';
